/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Bell, ShoppingCart as ShoppingCartIcon } from "lucide-react";

import { TestIds } from "../../../../testIds";
import { useCartHeaderData } from "../../hooks/useCartHeaderData";

import { HeaderIconButton } from "./HeaderIconButton";
import { PickupDeliveryButton } from "./PickupDeliveryButton";

export const DesktopCartHeader = () => {
  const {
    canUse,
    canCreateCartOrder,
    canViewProShop,
    cartItemCount,
    notificationCount,
    showNotifications,
    isDelivery,
    pickupOrDeliveryMode,
    pickupOrDeliveryAddress,
    goToCart,
    openNotifications,
    openPickupModal,
  } = useCartHeaderData();

  if (!canUse) {
    return <div className="min-h-[4.125rem] w-full" />;
  }

  return (
    <div className="flex w-full items-center justify-between text-white">
      {canViewProShop && (
        <PickupDeliveryButton
          isDelivery={isDelivery}
          label={pickupOrDeliveryMode ?? "Pickup / delivery"}
          value={pickupOrDeliveryAddress ?? "Set delivery method"}
          onClick={openPickupModal}
        />
      )}
      <div className="flex grow justify-end gap-(--gap-md)">
        {showNotifications && (
          <HeaderIconButton
            icon={<Bell aria-hidden size={20} />}
            count={notificationCount}
            ariaLabel="Notifications"
            testId={TestIds.components.cartHeader.inboxButton}
            onClick={openNotifications}
          />
        )}
        {canCreateCartOrder && (
          <HeaderIconButton
            icon={<ShoppingCartIcon aria-hidden size={20} />}
            count={cartItemCount}
            ariaLabel="Cart"
            testId={TestIds.components.cartHeader.cartShortcutButton}
            onClick={goToCart}
          />
        )}
      </div>
    </div>
  );
};

export default DesktopCartHeader;
